<style src='./_vue.sass' lang='sass'></style>
<template>
    <div :class='"kec-select-adv " + (hasGroup ? " main-width " : "") + selectClass'>
        <button class='ks-btn ks-dropdown-text' @click='__showHidden' type='button'>
            <slot name='select-res' :obj='value'>
                <span class='title'>{{ value.title }}</span>
            </slot>
            <span class="ks-caret"></span>
        </button>
        <div class='select-content' v-show='isShow'>
            <div class="select-search" v-if='search'>
                <input type="text" :placeholder="$trans(`输入关键字`)" class="select-search-text ks-form-text" v-model='searchFilter'>
                <i class="icon icon-search-20"></i>
            </div>
            <div class='info'>
                <ul class='group-title' v-if='hasGroup'>
                    <li :class='["group-title-item " ,
                        {"title-active": titleIndex == key,
                        "group-title-item-last": key == groupTitleList.length - 1}
                    ]' v-for='(item, key) in groupTitleList' @click='__setTitleIndex(key)'>
                        <slot name='select-title' :obj="item">
                            <span>{{ item.title }}</span>
                        </slot>
                    </li>
                </ul>
                <ul :class='"group-content " + (hasGroup ? "": "notitle-width")'>
                    <li :class='"group-content-item " + itemClass + (item.disabled ? " c-disabled" : "")' v-for='(item, index) in groupList' @click='__setValue(item)'>
                        <slot name='select-content' :obj="item">
                            <span>{{ item.text }}</span>
                        </slot>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                groupTitleList: [],
                groupList: [],
                titleIndex: -1,
                isShow: false,
                searchFilter: ''
            };
        },
        props: {
            hasGroup: {
                type: Boolean,
                default: false
            },
            search: {
                type: Boolean,
                default: false
            },
            groupTitleKey: {
                type: String,
                default: 'title'
            },
            groupKey: {
                type: String,
                default: 'group'
            },
            data: {
                type: Array,
                default: []
            },
            value: {
                type: Object,
                default: function() {
                    return {};
                }
            },
            selectClass: String,
            itemClass: String,
            searchKey: {
                type: String,
                default: 'title'
            }
        },
        mounted() {
            var self = this;
            this.groupList = this.data;
            this.$nextTick(() => {
                $(document).on('click', self.close).on('ks-select-click',  self.close);
            });
        },
        destroyed() {
            var self = this;
            $(document).off('click', self.close).off('ks-select-click',  self.close);
        },
        methods: {
            close(event) {
                var _con = $('.kec-select-adv');
          		  if(!_con.is(event.target) && _con.has(event.target).length === 0){
          		      this.isShow = false;
          		  }
            },
            __setTitleIndex(index) {
                this.titleIndex = index;
            },
            __setValue(item) {
                if (!item.disabled) {
                    this.isShow = false;
                    this.$emit('input', item);
                    if (!_.isEqual(this.value, item)) {
                        this.$emit('change', item);
                    }
                    this.$nextTick(() => {
                        $(document).trigger('ks-select-click');
                    });
                }
            },
            __showHidden() {
                this.isShow = !this.isShow;
            },
            formateGroupData() {
                if (this.hasGroup) {
                    var data = this.data;
                    var index = this.titleIndex;
                    var groupKey = this.groupKey;
                    if (index > -1)
                        this.groupList = data[index] && data[index][groupKey] || [];
                }
            }
        },
        watch: {
            searchFilter() {
                var data = this.data;
                var searchFilter = this.searchFilter;
                var searchKey = this.searchKey;
                if (this.search && searchFilter) {
                    if (!this.hasGroup) {
                        this.groupList = _.filter(data, (item) => {
                            return ~item[searchKey].indexOf(searchFilter);
                        });
                    }
                } else {
                    this.groupList = data;
                }
            },
            data() {
                var data = _.cloneDeep(this.data);
                var groupTitleKey = this.groupTitleKey;
                if (!_.isEmpty(data)) {
                    if (this.hasGroup) {
                        var titleList = _.map(data, groupTitleKey);
                        var titleTemplate = [];
                        _.map(titleList, (item) => {
                            titleTemplate.push({
                                title: item,
                                templateClass: (_.find(data, (i) => {
                                      return i[groupTitleKey] == item;
                                }) || {}).templateClass
                            });
                            return item;
                        });
                        this.groupTitleList = titleTemplate;
                        this.titleIndex = 0;
                    } else {
                        this.groupList = data;
                    }
                    this.formateGroupData();
                } else {
                    this.groupList = [];
                    this.groupTitleList = [];
                }

            },
            titleIndex() {
                this.formateGroupData();
            }
        }
    }
</script>
